import { create } from 'zustand'

// 進行中セッションのタイマー状態を管理
// データ自体（セット履歴等）は API から都度取得するためここでは持たない

type WorkoutTimerState = {
  // タイマーがどのセッションのものか。別セッションを開いたらタイマーを持ち越さないために使う
  sessionId: number | null
  // セット開始時刻（ミリ秒）— 経過時間を表示するために使用
  setStartedAt: number | null
  // インターバル開始時刻（ミリ秒）
  restStartedAt: number | null
  // インターバルの目標秒数
  restTargetSeconds: number | null
  // 現在の選択（テンプレート上での位置）
  currentItemIndex: number
  currentSetIndex: number

  bindSession: (sessionId: number) => void
  startSet: () => void
  endSet: () => void
  startRest: (targetSeconds: number) => void
  cancelRest: () => void
  setCurrentPosition: (itemIndex: number, setIndex: number) => void
  reset: () => void
}

const now = (): number => Date.now()

const initialTimerState = {
  setStartedAt: null,
  restStartedAt: null,
  restTargetSeconds: null,
  currentItemIndex: 0,
  currentSetIndex: 1,
}

export const useWorkoutStore = create<WorkoutTimerState>((set) => ({
  sessionId: null,
  ...initialTimerState,
  bindSession: (sessionId: number) =>
    set((state) => (state.sessionId === sessionId ? state : { ...initialTimerState, sessionId })),
  startSet: () => set({ setStartedAt: now(), restStartedAt: null, restTargetSeconds: null }),
  endSet: () => set({ setStartedAt: null }),
  startRest: (targetSeconds: number) =>
    set({ restStartedAt: now(), restTargetSeconds: targetSeconds, setStartedAt: null }),
  cancelRest: () => set({ restStartedAt: null, restTargetSeconds: null }),
  setCurrentPosition: (itemIndex: number, setIndex: number) =>
    set({ currentItemIndex: itemIndex, currentSetIndex: setIndex }),
  reset: () => set({ sessionId: null, ...initialTimerState }),
}))

// Safari/古いブラウザ向けの prefixed AudioContext 型
type WindowWithWebkit = Window & { webkitAudioContext?: typeof AudioContext }

// 通知音（Web Audio で短いビープを鳴らす）
export const playBeep = (durationMs = 200, frequency = 880): void => {
  try {
    const Ctx = window.AudioContext ?? (window as WindowWithWebkit).webkitAudioContext
    if (!Ctx) return
    const ctx = new Ctx()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.frequency.value = frequency
    osc.type = 'sine'
    osc.connect(gain)
    gain.connect(ctx.destination)
    gain.gain.setValueAtTime(0.3, ctx.currentTime)
    osc.start()
    setTimeout(() => {
      osc.stop()
      void ctx.close()
    }, durationMs)
  } catch (err) {
    console.warn('Beep failed:', err)
  }
}

export const vibrate = (pattern: number | number[]): void => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern)
  }
}
